import React from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import Text from 'app/components/base/Text'
import ReplyDialog from 'app/components/dialogs/ReplyDialog'
import useModal from 'app/hooks/useModal'

type ReplyLinkProps = {
  reviewId: string
}

const ReplyLink: RFC<ReplyLinkProps> = ({ reviewId }) => {
  const { open, showModal, hideModal } = useModal()

  return (
    <>
      <Text
        variant="body2"
        sx={{
          fontWeight: 500,
          color: 'text.light',
          ...Platform.select({
            web: {
              '&:hover': {
                cursor: 'pointer',
                color: 'secondary.dark'
              }
            }
          })
        }}
        onClick={showModal}
      >
        <FormattedMessage defaultMessage="Reply" />
      </Text>

      {open && (
        <ReplyDialog open={open} onClose={hideModal} reviewId={reviewId} />
      )}
    </>
  )
}

export default ReplyLink
